"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaskCompletion = void 0;
const React = __importStar(require("react"));
const styled_1 = __importDefault(require("@emotion/styled"));
const IconTextSpan_1 = require("../icon-text-span/IconTextSpan");
const theme_1 = __importDefault(require("../styles/theme"));
const types_1 = require("../../../entities/fact/types");
const MarginWrapper_1 = require("../margin/MarginWrapper");
const Wrapper = styled_1.default.div `
	${theme_1.default.typography.b1}
`;
const getDisplay = (erroring, completion) => {
    if (erroring)
        return ['cross', 'error'];
    switch (completion) {
        case types_1.TaskCompletionState.INPUT_REQUIRED:
            return ['exclamation', 'error'];
        case types_1.TaskCompletionState.REVIEW_REQUIRED:
            return ['ellipses', 'primary'];
        default:
        case types_1.TaskCompletionState.COMPLETE:
            return ['check', 'success'];
    }
};
const message = (completion) => {
    switch (completion) {
        case types_1.TaskCompletionState.INPUT_REQUIRED:
            return 'This section is incomplete.';
        case types_1.TaskCompletionState.REVIEW_REQUIRED:
        case types_1.TaskCompletionState.COMPLETE:
        default:
            return 'This section is complete.';
    }
};
const TaskCompletion = (props) => {
    const { completion, error } = props;
    const erroring = !!error;
    const [icon, display] = getDisplay(erroring, completion);
    return (React.createElement(MarginWrapper_1.MarginWrapper, null,
        React.createElement(Wrapper, null,
            React.createElement(IconTextSpan_1.IconTextSpan, { icon: icon, text: error || message(completion), display: display, iconSize: "large", errorTextColour: true }))));
};
exports.TaskCompletion = TaskCompletion;
//# sourceMappingURL=TaskCompletion.js.map